import { Autocomplete, Box, TextField, Typography } from '@mui/material'
import { t } from 'i18next'
import { Option } from '../../components/Form/Inputs/SelectInput'
import { SettlementMethod } from '../../store/types/enums/SettlementMethod'

type AutocompleteSettlementTypesProps = {
  value: SettlementMethod
  onChange: (value: SettlementMethod) => void
}

export const settlementMethodOptions: Option[] = [
  { value: SettlementMethod.FLAT, label: `page.employments.settlementsTypes.${SettlementMethod.FLAT}` },
  { value: SettlementMethod.HOURLY, label: `page.employments.settlementsTypes.${SettlementMethod.HOURLY}` },
]

const AutocompleteSettlementTypes = ({ value, onChange }: AutocompleteSettlementTypesProps) => {
  return (
    <Autocomplete
      value={settlementMethodOptions.find(opt => opt.value === value) || undefined}
      onChange={(_, newValue) => {
        if (newValue) {
          onChange(newValue.value as SettlementMethod)
        }
      }}
      disableClearable
      aria-label={t('page.employments.table.settlementType')}
      options={settlementMethodOptions}
      getOptionLabel={option => t(option.label)}
      noOptionsText={t('page.employments.table.settlementType')}
      renderGroup={params => (
        <div key={params.key}>
          <Box sx={{ px: 1.5, py: 1 }}>
            <Typography variant="body1" sx={{ color: 'text.highEmphasis' }}>
              {params.group}
            </Typography>
          </Box>
          <Box sx={{ color: 'text.base' }}>{params.children}</Box>
        </div>
      )}
      renderInput={params => (
        <TextField {...(params as any)} size={'small'} label={t('page.employments.table.settlementType')} />
      )}
      isOptionEqualToValue={(option, val) => {
        return option.value === (val as Option)?.value
      }}
    />
  )
}

export default AutocompleteSettlementTypes
